import { useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import userCore from "../../core/shopUser.core";
import { useTranslation } from "../../core/translation.core";
import { AdminUser } from "../../types/user";
import SolidBtn from "../form/solidBtn.comp";
import SolidWeakBtn from "../form/solidWeakBtn.comp";
import TrashIcon from "../../icons/trash.icon";

export default function RemoveUserBtn({ user }: { user: AdminUser }) {
  const { t, msg } = useTranslation();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const queryClient = useQueryClient();

  function remove() {
    dialogRef.current?.showModal();
  }

  async function confirm() {
    dialogRef.current?.close();
    await userCore.removeAdminUser(user.adminUserId);
    queryClient.invalidateQueries({ queryKey: ["shop"] });
  }

  const Dialog = () => {
    return (
      <dialog ref={dialogRef} className="dark:bg-her-blackOlive dark:text-white p-10 rounded-lg">
        <h1 className="text-xl mb-4">{t(msg.user.removeUserConfirmation)}</h1>
        <p>
          {t(msg.user.removeUserClickToConfirm)} <span className="font-bold">{user.email}</span>
        </p>
        <div className="flex gap-4 mt-6">
          <SolidBtn dataRole="confirm" onClick={() => confirm()}>
            {t(msg.user.confirm)}
          </SolidBtn>
          <SolidWeakBtn dataRole="cancel" onClick={() => dialogRef.current?.close()}>
            {t(msg.form.cancel)}
          </SolidWeakBtn>
        </div>
      </dialog>
    );
  };

  return (
    <>
      <button
        data-action="remove"
        onClick={remove}
        className="bg-red-600 text-white flex items-center gap-2 px-2 py-1 rounded-md"
      >
        <TrashIcon className="w-4 h-4" />
        {t(msg.form.remove)}
      </button>
      <Dialog />
    </>
  );
}
